interface HtmlSourceEditorProps {
  /** The current HTML. */
  value: string;
  /** Called with the new HTML on every edit. */
  onChange: (html: string) => void;
}

/**
 * Raw-HTML view of a product description — Shopify's "Show HTML" mode. A plain
 * textarea, so it carries no rich-text editor dependency and stays in the main
 * bundle (the heavier {@link RichTextEditor} is loaded lazily).
 */
export function HtmlSourceEditor({ value, onChange }: HtmlSourceEditorProps) {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      spellCheck={false}
      className="h-64 w-full rounded-md border border-input bg-background p-3 font-mono text-xs text-foreground outline-none focus:ring-1 focus:ring-ring"
    />
  );
}
